import Vue from 'vue';
import VueRouter from 'vue-router';

import CalendarView from '../views/CalendarView';
import WizardView from '../views/WizardView';
import WizardDateTime from '../components/WizardDateTime';
import WizardDefaultText from '../components/WizardDefaultText';
import WizardDefaultPhoto from '../components/WizardDefaultPhoto';
import WizardPostOptions from '../components/WizardPostOptions';
import CalendarWeek from '../components/CalendarWeek';
import CalendarDay from '../components/CalendarDay';

/* eslint-disable no-use-before-define vars-on-top */
Vue.use(VueRouter);
const router = new VueRouter({
  // disable history api because we do not need it
  abstract: true,

  // make sure transitions trigger on initial page load
  transitionOnLoad: true,
});

router.map({
  '/': {
    name: 'calendar',
    component: CalendarView,
    title: 'POST Planner',
    subRoutes: {
      '/week': {
        name: 'calendar-week',
        component: CalendarWeek,
      },
      '/day': {
        name: 'calendar-day',
        component: CalendarDay,
      },
    },
  },

  '/show/:showId': {
    name: 'wizard',
    component: WizardView,
    title: 'Create or Edit Show',
    subRoutes: {
      '/date-time': {
        name: 'date-time',
        component: WizardDateTime,
        subtitle: 'Date and Time',
      },
      '/default-text': {
        name: 'default-text',
        component: WizardDefaultText,
        subtitle: 'Default Text',
      },
      '/default-photo': {
        name: 'default-photo',
        component: WizardDefaultPhoto,
        subtitle: 'Default Photo',
      },
      '/post-options': {
        name: 'post-options',
        component: WizardPostOptions,
        subtitle: 'Default Post Options',
      },
    },
  },
});

// Show calendar-week when first starting up
router.redirect({
  '/': '/week',
});

// Scroll to top upon changing a route
router.beforeEach(() => {
  window.scrollTo(0, 0);
});

export default router;



// WEBPACK FOOTER //
// ./src/core/router.js